export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Isochrone/GPisochronOpen.png?c8edd957da59a98506ca5daf31bf7dc8";